module.exports = __webpack_public_path__ + "img/icon_share_white.cd47989.svg";